import React from 'react';
import { useTranslation } from 'react-i18next';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Modal from '../../../_ui/Modal/Modal';
import Button from '../../../modules/Button/Button';
import { useHistory } from 'react-router-dom';
import paths from '../../../_helpers/paths';

function CheckContingentModal({ isOpen }) {
  const { t } = useTranslation();
  const history = useHistory();

  const handleCloseAndRedirect = () => {
    history.push(paths.voucherWaitingList);
  };

  return (
    <Modal open={isOpen} onClose={handleCloseAndRedirect} disableBackdropClick>
      <DialogContent>
        <div style={{ fontSize: '16px', lineHeight: '1.4' }}>
          {t('serviceRequest_checkContingent')}
          <br />
          {t('serviceRequest_checkContingentMessage')}
        </div>
      </DialogContent>
      <DialogActions>
        <Button text={t('serviceRequest_checkContingentOkButton')} onClick={handleCloseAndRedirect} color="primary" />
      </DialogActions>
    </Modal>
  );
}

export default CheckContingentModal;
